var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBakground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1538,
    height: 835,
    viewBox: "0 0 1538 835",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdd_6814_13057)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 50,
    width: 1394,
    height: 691,
    rx: 32,
    fill: "url(#paint0_linear_6814_13057)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_6814_13057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 143C90 138.582 93.5817 135 98 135H1441C1445.42 135 1449 138.582 1449 143V694C1449 711.673 1434.67 726 1417 726H122C104.327 726 90 711.673 90 694V143Z",
    fill: "#333054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 136H1441C1444.87 136 1448 139.134 1448 143V694C1448 711.121 1434.12 725 1417 725H122C104.879 725 91 711.121 91 694V143C91 139.134 94.134 136 98 136Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_6814_13057)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1442,
    y: 122,
    width: 1153,
    height: 48,
    rx: 24,
    transform: "rotate(180 1442 122)",
    fill: "url(#paint1_linear_6814_13057)",
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 141,
    width: 1040,
    height: 585,
    fill: "url(#paint2_linear_6814_13057)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 434.824,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 174.531,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 218.648,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 262.766,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 306.883,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 351,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 395.117,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 434.824,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 476.293,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 517.766,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 559.234,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 600.707,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 642.176,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 985,
    y: 683.648,
    width: 251,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 298,
    y: 174.531,
    width: 638,
    height: 232.059,
    fill: "#8785D2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 476.293,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 517.766,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 559.234,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 600.707,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 642.176,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 298,
    y: 683.648,
    width: 638,
    height: 11.4706,
    fill: "#ACABAB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 93,
    r: 12,
    fill: "url(#paint3_radial_6814_13057)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 93,
    r: 12,
    fill: "url(#paint4_radial_6814_13057)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 93,
    r: 12,
    fill: "url(#paint5_radial_6814_13057)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdd_6814_13057",
    x: 0,
    y: 0,
    width: 1538,
    height: 835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6814_13057"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 37,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_6814_13057"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00923611 0 0 0 0 0.0120333 0 0 0 0 0.0791667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_6814_13057",
    result: "effect2_dropShadow_6814_13057"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_6814_13057",
    result: "effect3_dropShadow_6814_13057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_6814_13057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_6814_13057",
    x: 78,
    y: 123,
    width: 1383,
    height: 615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6814_13057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6814_13057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_6814_13057",
    x: 279,
    y: 64,
    width: 1173,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6814_13057"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_6814_13057",
    result: "effect2_dropShadow_6814_13057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6814_13057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6814_13057",
    x1: 72,
    y1: 396.079,
    x2: 1477.52,
    y2: 396.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4496",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6814_13057",
    x1: 1442,
    y1: 146.04,
    x2: 2604.53,
    y2: 146.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4496",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6814_13057",
    x1: 581.375,
    y1: 345.479,
    x2: 1812.71,
    y2: 864.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18162B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F416F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6814_13057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 96.5) rotate(122.005) scale(4.71699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6814_13057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158 96.5) rotate(122.005) scale(4.71699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB3B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6814_13057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203 96.5) rotate(122.005) scale(4.71699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC016"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakground);
export default __webpack_public_path__ + "static/media/bakground.727ebf98e1008600b4f66560619236af.svg";
export { ForwardRef as ReactComponent };